// extracted by mini-css-extract-plugin
export var actionButton = "_kh-0";
export var fileInput = "_kh-2";
export var paperclip = "_kh-1";